import {
  IAiOnboardingDraft,
} from '../models/AiOnboardingModels';

import {
  RecapResult,
  SaveOnboardingDetailsFields,
} from './types';

const validationPathAliases: Record<string, keyof SaveOnboardingDetailsFields> = {
  pharmacistCapacityId: 'professionalCapacityId',
};

const getValidationErrorParts = (validationError: string) => {
  const separatorIndex = validationError.indexOf(':');

  if (separatorIndex < 0) {
    return ['input', validationError] as const;
  }

  const path = validationError.slice(0, separatorIndex).replace(/^fields\./, '');
  const message = validationError.slice(separatorIndex + 1).trim();

  return [path, message] as const;
};

export const getRecapValidationErrors = (validationErrors: string[]) =>
  validationErrors.reduce<Record<string, string>>((errors, validationError) => {
    const [path, message] = getValidationErrorParts(validationError);
    const normalizedPath = validationPathAliases[path] ?? path;

    if (!errors[normalizedPath]) {
      errors[normalizedPath] = message;
    }

    return errors;
  }, {});

export const getRecapProfile = (
  onboardingDetails: IAiOnboardingDraft | null,
): SaveOnboardingDetailsFields | null =>
  (onboardingDetails
    ? { ...onboardingDetails } as SaveOnboardingDetailsFields
    : null);

export const getCorrectedRecapFieldNames = (
  initialProfile: IAiOnboardingDraft | null,
  updatedProfile: SaveOnboardingDetailsFields,
) => {
  if (!initialProfile) {
    return Object.keys(updatedProfile);
  }

  return Object.keys(updatedProfile).filter((fieldName) => {
    const profileField = fieldName as keyof SaveOnboardingDetailsFields;

    return JSON.stringify(initialProfile[profileField])
      !== JSON.stringify(updatedProfile[profileField]);
  });
};

export const createRecapResult = (
  confirmed: boolean,
  correctedFieldNames: string[] = [],
): RecapResult =>
  ({
    confirmed,
    correctedFieldNames,
    fieldsCorrected: correctedFieldNames.length > 0,
  });
